/**
 * Addon Products - Quantity Management & Sticky Bar
 */
(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('Initializing addon products...');
    
    const stickyBar = document.querySelector('[data-addon-sticky-bar]');
    const addonContainer = document.querySelector('[data-addon-products-container]');
    
    if (!addonContainer) {
      console.log('No addon products container found');
      return;
    }
    
    console.log('Addon products container found');

    // Update sticky bar totals
    function updateSummary() {
      let totalQuantity = 0;
      let totalPrice = 0;

      // Get all addon product inputs
      const addonInputs = document.querySelectorAll('.quantity-input__field[data-variant-id]');
      console.log('Found', addonInputs.length, 'addon inputs');
      
      addonInputs.forEach(input => {
        const quantity = parseInt(input.value, 10) || 0;
        console.log('Input value:', input.value, 'Parsed quantity:', quantity);
        
        if (quantity > 0) {
          totalQuantity += quantity;
          
          // Get price from the price element
          const card = input.closest('.product-quantity-card');
          if (card) {
            const priceElement = card.querySelector('.price-item--regular');
            if (priceElement) {
              const priceText = priceElement.textContent.trim();
              const priceMatch = priceText.match(/[\d.,]+/);
              if (priceMatch) {
                const priceString = priceMatch[0].replace('.', '').replace(',', '.');
                const priceValue = parseFloat(priceString);
                const priceInCents = Math.round(priceValue * 100);
                totalPrice += priceInCents * quantity;
                console.log('Added price:', priceValue, 'x', quantity, '=', (priceInCents * quantity / 100));
              }
            }
          }
        }
      });

      console.log('Total quantity:', totalQuantity, 'Total price:', (totalPrice / 100).toFixed(2));

      // Update sticky bar if it exists
      if (stickyBar) {
        const stickyCount = stickyBar.querySelector('[data-sticky-total-count]');
        const stickyPrice = stickyBar.querySelector('[data-sticky-total-price]');
        const stickyButton = stickyBar.querySelector('[data-sticky-add-button]');
        
        if (stickyCount) {
          stickyCount.textContent = totalQuantity;
          console.log('Updated sticky count to:', totalQuantity);
        }
        if (stickyPrice) {
          const formattedPrice = window.FoxTheme && window.FoxTheme.Currency 
            ? FoxTheme.Currency.formatMoney(totalPrice, window.FoxTheme.settings.moneyFormat)
            : totalPrice;
          stickyPrice.textContent = formattedPrice;
          console.log('Updated sticky price to:', formattedPrice);
        }
        
        // Show/hide sticky bar
        if (totalQuantity > 0) {
          stickyBar.classList.add('addon-sticky-bar--visible');
          if (stickyButton) stickyButton.disabled = false;
          console.log('Sticky bar visible');
        } else {
          stickyBar.classList.remove('addon-sticky-bar--visible');
          if (stickyButton) stickyButton.disabled = true;
          console.log('Sticky bar hidden');
        }
      }
    }

    // Quantity button click handlers
    document.addEventListener('click', function(e) {
      const button = e.target.closest('.quantity-input__button');
      if (!button) return;
      
      console.log('Quantity button clicked:', button.dataset.action);
      
      const targetId = button.dataset.target;
      if (!targetId) {
        console.error('No target ID found on button');
        return;
      }
      
      const input = document.getElementById(targetId);
      if (!input) {
        console.error('Input not found with ID:', targetId);
        return;
      }
      
      const action = button.dataset.action;
      const currentValue = parseInt(input.value, 10) || 0;
      const maxValue = parseInt(input.dataset.max, 10) || 99;
      const minValue = parseInt(input.getAttribute('min'), 10) || 0;
      
      console.log('Current:', currentValue, 'Min:', minValue, 'Max:', maxValue);
      
      if (action === 'increase' && currentValue < maxValue) {
        input.value = currentValue + 1;
        console.log('Increased to:', input.value);
        updateSummary();
      } else if (action === 'decrease' && currentValue > minValue) {
        input.value = currentValue - 1;
        console.log('Decreased to:', input.value);
        updateSummary();
      } else {
        console.log('Cannot change - at limit');
      }
    });

    // Manual input changes
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('quantity-input__field') && e.target.dataset.variantId) {
        console.log('Input changed manually:', e.target.value);
        updateSummary();
      }
    });

    // Initial update
    updateSummary();

    // Function to add only addon products to cart
    window.addAddonsToCart = function(buttonElement) {
      const addonInputs = document.querySelectorAll('.quantity-input__field[data-variant-id]');
      const items = [];
      
      // Get only addon products
      addonInputs.forEach(input => {
        const quantity = parseInt(input.value, 10) || 0;
        if (quantity > 0) {
          const variantId = parseInt(input.dataset.variantId, 10);
          items.push({
            id: variantId,
            quantity: quantity
          });
        }
      });
      
      if (items.length === 0) {
        alert('Please select at least one add-on product');
        return;
      }
      
      console.log('Adding addons to cart:', items);
      
      // Disable button
      if (buttonElement) {
        buttonElement.setAttribute('aria-disabled', 'true');
        buttonElement.classList.add('btn--loading');
      }
      
      // Get sections to bundle
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      
      // Prepare request body
      const requestBody = {
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      };
      
      // Add to cart via Shopify API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(async (data) => {
        console.log('Addons added to cart:', data);
        
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'Failed to add to cart');
        }
        
        // Fetch updated cart
        const cartResponse = await fetch('/cart.js');
        const cartJson = await cartResponse.json();
        
        if (data.sections) {
          cartJson.sections = data.sections;
        }
        
        // Publish cart update
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
        
        // Open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.show) {
          setTimeout(() => {
            cartDrawer.show(buttonElement);
          }, 100);
        }
        
        // Reset addon quantities after successful add
        addonInputs.forEach(input => {
          input.value = 0;
        });
        updateSummary();
      })
      .catch(error => {
        console.error('Error adding addons to cart:', error);
        alert('Error adding products to cart. Please try again.');
      })
      .finally(() => {
        if (buttonElement) {
          buttonElement.removeAttribute('aria-disabled');
          buttonElement.classList.remove('btn--loading');
        }
      });
    };
  }
})();
